<template>
  <my-view></my-view>
</template>

<script>
import MyView from "@/pages/publicView/personalCenter/home_view.vue";

export default {
  components: { MyView },
};
</script>